// extracted by mini-css-extract-plugin
export var cartIcon = "_l5-0";
export var cartIconContainer = "_l5-1";